import { PlanName } from './billing-helper'
import { debugLog } from '../utils/log-helper'

/**
 * Stripe Price IDs for Explorer tier
 * - local/dev: price_1ScibY1jHQk9Q0Ema15rPx7d
 * - dev?:      price_1SciqK094ZzSMhhKACLzxOzX
 * - prod:      price_1ScilgP8peowG65JWUJnmHfF
 */
const EXPLORER_PRICE_IDS = new Set([
  'price_1sciby1jhqk9q0ema15rpx7d',
  'price_1sciqk094zzsmhhkaclzxozx',
  'price_1scilgp8peowg65jwujnmhff',
].map(id => id.toLowerCase()))

/**
 * Stripe Price IDs for VIP tier
 * - local/dev: price_1ShtBp1jHQk9Q0EmxqNd4aKN
 * - dev?:      price_1ShtIn094ZzSMhhKGOfdjIm6
 * - prod:      price_1ShtLtP8peowG65Jl35nVANf
 */
const VIP_PRICE_IDS = new Set([
  'price_1shtbp1jhqk9q0emxqnd4akn',
  'price_1shtin094zzsmhhkgofdjim6',
  'price_1shtltp8peowg65jl35nvanf',
].map(id => id.toLowerCase()))

/**
 * Maps subscriptionPlanId from backend to PlanName
 * 
 * Mapping logic:
 * - null/empty/undefined → Free tier (returns null)
 * - Exact match with known Explorer price IDs → Explorer
 * - Exact match with known VIP price IDs → VIP
 * - Contains 'vip' (case-insensitive) → VIP (heuristic fallback)
 * - Contains 'explorer' (case-insensitive) → Explorer (heuristic fallback)
 * - Unrecognized → null with debugLog
 * 
 * @param subscriptionPlanId - The plan ID from eater.subscriptionPlanId
 * @returns PlanName or null if Free/unrecognized
 */
export function mapSubscriptionPlanIdToTier(subscriptionPlanId: string | null | undefined): PlanName | null {
  if (!subscriptionPlanId || subscriptionPlanId.trim() === '') {
    return null // No plan ID = Free tier
  }
  
  // Normalize to lowercase for comparison (case-insensitive)
  const normalized = subscriptionPlanId.trim().toLowerCase()
  
  // Check for exact match with known Explorer price IDs
  if (EXPLORER_PRICE_IDS.has(normalized)) {
    return 'explorer'
  }
  
  // Check for exact match with known VIP price IDs
  if (VIP_PRICE_IDS.has(normalized)) {
    return 'vip'
  }
  
  // Heuristic fallback: check for contains match (handles future variations)
  if (normalized.includes('vip')) {
    return 'vip'
  }
  
  if (normalized.includes('explorer')) {
    return 'explorer'
  }
  
  // Unrecognized plan ID - warn and return null
  debugLog(`[tier-helper] Unrecognized subscriptionPlanId: ${subscriptionPlanId}`)
  return null
}
